import gsap, { Power2 as Ease } from 'gsap'
export class CommonAccordions {
  constructor() {
    const duration = 0.5
    this.els = [...document.getElementsByClassName('js-common-accordion')]
    if (this.els.length === 0) return
    // console.log(this.els)

    this.els.forEach((el) => {
      const container = el.querySelector('.js-accordion-container')
      const inner = el.querySelector('.js-accordion-inner')
      const button = el.querySelector('.js-accordion-button')
      const { closeSize } = el.dataset
      if (container === null || inner === null || button === null) return
      let isOpen = false
      container.style.cssText = `
      overflow: hidden;
      height: ${closeSize || '0'}
      `

      button.addEventListener('click', () => {
        if (isOpen) {
          isOpen = false
          this.scroll(el)
          el.classList.remove('is-open')
          gsap.fromTo(
            container,
            duration,
            {
              height: inner.clientHeight,
            },
            {
              ease: Ease.easeOut,
              height: closeSize || 0,
            },
          )
        } else {
          isOpen = true
          el.classList.add('is-open')
          gsap.to(container, duration, {
            height: inner.clientHeight,
            ease: Ease.easeOut,
            onComplete: () => {
              container.style.height = 'auto'
            },
          })
        }
      })
    })
  }

  scroll(el) {
    const rectTop = el.getBoundingClientRect().top
    const targetPosition = window.scrollY + rectTop
    window.scrollTo({
      top: targetPosition - document.getElementById('js-header').clientHeight,
      behavior: 'instant',
    })
  }
}
